import { roleBasedAccessControlConstants } from "../constants";

function getRoleOfUserFromReduxState(userDetails) {
  return (
    userDetails?.signInUserSession?.accessToken?.payload?.["cognito:groups"]
      ?.filter((ite) =>
        roleBasedAccessControlConstants.data360Roles.includes(ite)
      )
      ?.sort(roleBasedAccessControlConstants.data360Roles.customSort)[0] || ""
  );
}

export { getRoleOfUserFromReduxState };
